<template>
  <v-snackbar
    v-model="options.show"
    top
    :timeout="5000"
  >
    <v-icon :color="options.type">
      {{ icon }}
    </v-icon>{{ options.message }}
    <v-btn
      icon
      color="white"
      @click="close()"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-snackbar>
</template>
<script>
export default {
  name: 'Snackbar',
  props: {
    options: {
      type: Object,
      default: () => {
        return {
          show: false,
          message: 'options.message is not set',
          type: 'success'
        }
      }
    }
  },
  data: () => ({
    //
  }),
  computed: {
    icon () {
      switch (this.options.type) {
        case 'success':
          return 'mdi-check-circle'

        case 'error':
          return 'mdi-alert-circle'

        default:
          return 'mdi-check-circle'
      }
    }
  },
  created () {
    //
  },
  methods: {
    close () {
      this.$emit('close-snackbar')
    }
  }
}
</script>
<style lang='scss'>
    #Snackbar {
        //
    }
</style>
